<template>
  <v-card
    class="mx-auto"
  >
    <v-card-title>
      Android APK
    </v-card-title>

    <v-card-subtitle>
      Descargas disponibles
    </v-card-subtitle>

    <v-card-actions>
      <v-btn
        color="orange lighten-2"
        text
        @click="show = !show"
      >
        Mostrar
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        icon
        @click="show = !show"
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider />

        <v-card-text 
          v-for="(item, index) of downloads"
          :key="index"
        >
          <input style="display:none;" type="text" :value="item.link" :id="`dapk${index}`">
          <v-btn
            block
            @click="handleCopy(`dapk${index}`)"
            :color="item.color"
          >
            {{item.name}}
          </v-btn>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    show: false,
  }),
  computed: {
    downloads () {
      return [
        {
          id: 'noPerm0_9_1',
          name: '[NEW] 0_9_1 sin pantalla de permisos',
          link: 'https://widgets.dviewcontent.com/dapk/new/NoPerm0_9_1/descubre.apk',
          color: 'blue',
        },
        {
          id: 'base0_9_0',
          name: '0_9_0 OLD',
          link: 'https://widgets.dviewcontent.com/dapk/new/OLD/descubre.apk',
          color: 'gray'
        },
      ]
    },
  },
  methods: {
    handleCopy (v) {
      var copyText = document.getElementById(v)
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(copyText.value)
      alert("URL copiado: " + copyText.value)
    },
  },
}
</script>
